import React from 'react';
import { Link } from 'react-router-dom';

function Chapter({ chapter }) {
  // Images are served from public folder
  const chapterLogo = `/${chapter.image}`;
  
  return (
    <Link to={`/chapter/${chapter.id}/page/0`} className="chapter-link">
      <div className="chapter">
        <div className="chapter-image">
          <img 
            src={chapterLogo} 
            alt={`Chapter ${chapter.label} logo`} 
          />
        </div>
        <div className="chapter-info">
          <h2 className="chapter-title">{chapter.title}</h2>
          <div className="chapter-date">{chapter.date}</div>
          <p className="chapter-description">{chapter.description}</p>
        </div>
      </div>
    </Link>
  );
}

export default Chapter; 